import { useEffect, useState } from 'react'
import { Data8Service } from '../../../../src/services/data-8'
import s from './styles.module.scss'

interface inputFieldTextProps {
    fieldName: string
    saveValue: (obj: { field: string; value: string }) => {
        success: boolean
        error: string
    }
    submitValue?: any
    enhanced?: boolean
    populateValue?: string
    placeholder?: string
}

export const InputFieldAddressLookup = (props: inputFieldTextProps) => {
    const { fieldName, saveValue, enhanced = false, populateValue, placeholder } = props
    const [valueToSave, setValueToSave] = useState(populateValue || '')
    const [error, setError] = useState<any>('')
    const [lookupResults, setLookupResults] = useState([])
    const [isSearching, setIsSearching] = useState(false)

    useEffect(() => {
        if (populateValue) {
            setValueToSave(populateValue)
        }
    }, [populateValue])

    const onChangeFunc = async (e: React.ChangeEvent<HTMLInputElement>) => {
        const newValue = e.currentTarget.value
        console.log('INPUT TEXT FIELD CHANGED...', newValue)

        setValueToSave(newValue)

        if (newValue.length > 3) {
            setIsSearching(true)
            await data8Lookup(newValue)
            setIsSearching(false)
        } else {
            setLookupResults([])
        }
        // saveAll(newValue);
    }

    const saveAll = async (newValue: string) => {
        setValueToSave(newValue)
        const saveResult = saveValue({ field: fieldName, value: newValue })
        // console.log(saveResult);
        if (!saveResult.success) {
            setError(saveResult.error)
        }
    }

    const data8Lookup = async (searchTerm: string) => {
        const lookupObject = {
            country: 'GB',
            search: searchTerm,
            telephoneNumber: '',
            session: '',
            options: {
                IncludeMR: false,
                IncludeNYB: false,
                PreferredLanguage: 'en',
            },
        }

        const data8Result = await Data8Service('PredictiveAddress', 'Search', lookupObject)

        if (!data8Result.Results || !data8Result.Results.length) {
            setError("Couldn't find address.")
            setLookupResults([])
            return
        }
        setError('')
        setLookupResults(data8Result.Results)
    }

    const toTitleCase = (str: string) => {
        return str.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase())
    }

    const selectAddress = async (value: string, label: string) => {
        saveValue({ field: fieldName, value: '' })

        await new Promise((resolve) => setTimeout(resolve, 50))

        const valueObject = {
            country: 'GB',
            id: value,
        }

        const retrieveResult = await Data8Service('PredictiveAddress', 'Retrieve', valueObject)

        console.log('Retrieve Result...', retrieveResult)

        saveValue({
            field: 'address',
            value: retrieveResult.Result.Address.Lines.filter((line: string) => line.trim() !== '').join(','),
        })

        setLookupResults([])
    }

    const handleInputClick = (e: React.MouseEvent<HTMLInputElement>) => {
        if (valueToSave.length > 3 && lookupResults.length === 0) {
            data8Lookup(valueToSave)
        }

        const isMobileWidth = window.innerWidth <= 992

        if (isMobileWidth) {
            const inputElement = e.currentTarget
            setTimeout(() => {
                const elementPosition = inputElement.getBoundingClientRect().top
                const offsetPosition = elementPosition + window.pageYOffset - 45
                window.scrollTo({
                    top: offsetPosition,
                    behavior: 'smooth',
                })
            }, 100)
        }
    }

    return (
        <>
            <div className={s.lookupContainer}>
                <div className={s.inputWrapper}>
                    <input
                        className={`${s.inputStyle} ${enhanced ? s.enhanced : ''}`}
                        type={'text'}
                        name={fieldName}
                        value={valueToSave}
                        onChange={onChangeFunc}
                        onClick={handleInputClick}
                        placeholder={placeholder}
                    />
                    {enhanced && (
                        <div className={s.searchIcon}>
                            {isSearching ? (
                                <div className={s.loadingSpinner}></div>
                            ) : (
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="20"
                                    height="20"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                >
                                    <circle cx="11" cy="11" r="8"></circle>
                                    <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                                </svg>
                            )}
                        </div>
                    )}
                </div>
                {error && <span className={`${s.notice}`}>{error}</span>}
                {lookupResults.length > 0 ? (
                    <>
                        <div className={`${s.lookupSelection} ${enhanced ? s.enhancedLookup : ''}`}>
                            <p>Please select address:</p>
                            <ul>
                                {lookupResults.map((item: any, index: number) => {
                                    return (
                                        <li
                                            key={index}
                                            style={{ zIndex: 100000 }}
                                            onClick={() => selectAddress(item.value, item.label)}
                                        >
                                            {item.label}
                                        </li>
                                    )
                                })}
                            </ul>
                        </div>
                    </>
                ) : null}
            </div>
        </>
    )
}
